import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-text-input',
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule],
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
})
export class TextInputComponent implements OnInit {
  @Input() label: string = '';
  @Input() appearance: 'fill' | 'outline' = 'outline';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() required: boolean = false;
  @Input() control: FormControl = new FormControl();
  @Input() hideRequiredMarker: boolean = false;
  @Input() autocomplete: 'off' | 'on' | '' = '';
  @Input() classes: string = '';
  @Input() value: string | null | undefined = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;

  constructor() {
  }

  ngOnInit(): void {
    if(!this.control.value){
      this.control.setValue(this.value);
    }
    this.control.valueChanges.subscribe( (value: any) => {
      this.valueChange.emit(value);
    });
  }

  onFocusOut(event: FocusEvent): void {
    const target = event.target as HTMLInputElement;
    this.focusOut.emit(target.value);
  }

  onEnter(event: Event): void {
    // Check if the key pressed is 'Enter'
    // and emit the value of the input field
    // to the parent component
    const e = event as KeyboardEvent;
    if (e.key === 'Enter') {
      const target = event.target as HTMLInputElement;
      this.focusOut.emit(target.value);
    }
  }

  focus(): void {
    this.inputElement.nativeElement.focus();
  }
}
